import { render } from "./TheNavigation.vue?vue&type=template&id=bf264c4a&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=bf264c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf264c4a"]])

export default __exports__